import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import classNames from "classnames";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import emptylist from "Assets/Svg/signingauth.svg";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import {
  instance,
  instanceMultipart,
} from "../../../../../../../Actions/AxiosInstance";
import { setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import { DatePickerComponent } from "../../../../../../../Component/Custom";
import DrawerHeader from "../../../../../../../Component/Headers/drawerHeader";
import {
  convertDateForBackend,
  getFormattedImageLink,
} from "../../../../../../../Utils";
import { TDTypeConsts } from "../../../../../business-configration/commons";
import AssignForm from "./AssignForm";
import Create from "./create";
import SigningAuthTimeline from "./signingauthtimeline";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },

  drawerPaper: {
    width: "30%",
  },
});

class SigningAuthority extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      bankdetails: [],
      allbankdetails: [],
      genderList: [],
      errors: {},
      searchValue: "",
      headers: [
        {
          key: "employeefullname",
          name: <FormattedMessage id="LbName" defaultMessage="Name" />,
          type: TDTypeConsts.SA_NAME,
        },
        {
          key: "fathername",
          name: (
            <FormattedMessage id="Lbfathername" defaultMessage="Father name" />
          ),
          type: TDTypeConsts.AUTHORITIES,
        },
        {
          key: "designationname",
          name: (
            <FormattedMessage id="Lbdesignation" defaultMessage="Designation" />
          ),
          type: TDTypeConsts.AUTHORITY_TYPE,
        },
        {
          key: "genderid",
          name: <FormattedMessage id="Lbgenderid" defaultMessage="Gender" />,
          type: TDTypeConsts.FALLBACK_OF_DEFAULT,
        },
        {
          key: "edit",
          name: <FormattedMessage id="Lbedit" defaultMessage="Edit" />,
        },
        {
          key: "delete",
          name: <FormattedMessage id="Lbdelete" defaultMessage="Delete" />,
        },
      ],
      timeline: [],
      startdate: moment().startOf("year"),
      enddate: moment(),
      istoday: true,
      allsigningauthority: [],
      open: false,
      data: false,
    };

    this.onCreateAuthority = this.onCreateAuthority.bind(this);
    this.OnFieldChange = this.OnFieldChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.OnFormSubmit = this.OnFormSubmit.bind(this);
    this.onBlurChange = this.onBlurChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onFathernamechange = this.onFathernamechange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.gettimeline = this.gettimeline.bind(this);
    this.GetAllSigningAuthority = this.GetAllSigningAuthority.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    this.GetAllSigningAuthority();
    this.GetGender();
    this.gettimeline();
  }

  gettimeline() {
    const { startdate, enddate } = this.state;
    instance
      .get(
        `payroll/signingauthoritylist/${convertDateForBackend(
          startdate,
        )}/${convertDateForBackend(enddate)}`,
      )
      .then((resp) => {
        const deleteindexes = [];
        let result = [];
        const data = get(resp, "data.result", []);
        data.forEach((x, i) => {
          if (
            get(x, `signingauthority[0].effectivefrom`, "") ==
            get(data, `[${i + 1}].signingauthority[0].effectivefrom`, "")
          ) {
            result.push({
              ...x,
              signingauthority2: data[i + 1].signingauthority,
            });
            deleteindexes.push(i + 1);
          } else {
            result.push({ ...x });
          }
        });
        result = result.filter(
          (x, i) => deleteindexes.find((y) => y != i) || true,
        );
        this.setState({ timeline: result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetAllSigningAuthority() {
    const URL = "payroll/signingauthority";
    instance
      .get(URL)
      .then((result) => {
        const allsigningauthority = result.data.result;
        const tempList = allsigningauthority;
        this.setState({ allsigningauthority, tempList, data: true });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetGender() {
    instance
      .get("superuser/getgender")
      .then((result) => {
        const genderList = result.data.result;
        // genderList.push({ "displayname": "Select Gender", "displayvalue": '' }, ...result.data.result)
        this.setState({ genderList });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  SearchEmployee = (search) => {
    if (search.length < 3) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 3
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: 1,
        featurekey: "payroll",
      };
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({ emplist: result.data.result });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  OnFormSubmit() {
    const {
      isexisting = false,
      employeefullname = null,
      fathername = null,
      file = null,
      designationname = null,
      genderid = null,
      signingauthorityid = null,
      signaturepath = null,
      employeeid = null,
    } = this.state;

    if (
      !employeefullname ||
      !fathername ||
      // !file ||
      (!isexisting && (!designationname || !genderid))
    ) {
      this.props.enqueueSnackbar("Please filled all required fields", {
        variant: "error",
      });
      return;
    }

    const URL = "payroll/signingauthority";
    const data = {
      signingauthority: {
        signingauthorityid,
        fathername,
        signaturepath,
        employeeid,
        employeefullname,
        designationname,
        genderid,
      },
    };
    instance
      .post(URL, data)
      .then(() => {
        this.setState(
          {
            open: !this.state.open,
            employeefullname: "",
            fathername: "",
            imgname: "",
            designationname: "",
            genderid: null,
            signaturepath: "",
            selectedgender: null,
            signingauthorityid: null,
            selectedemployee: null,
            isexisting: false,
          },
          () => {
            this.GetAllSigningAuthority();
          },
        );
        this.props.enqueueSnackbar("saved successfully", {
          variant: "success",
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  OnFieldChange(name, type, e) {
    if (name == "genderid") {
      this.setState({
        [name]: e.displayvalue,
        selectedgender: e,
      });
    } else {
      this.setState({
        [name]: e.target.value,
        // employeeid: null,
      });
    }
  }

  handleChange() {
    this.setState({
      isexisting: !this.state.isexisting,
    });
  }

  searchEmployee = (search) => {
    if (search.length < 3) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 3
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: 1,
        featurekey: "biometric",
      };
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({ emplist: result.data.result });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  onBlurChange(name, type, e) {
    this.setState({
      selectedemployee: e,
      [name]: e.displayname,
      employeeid: e.displayvalue,
    });
  }

  getFiles1(files) {
    const file = files[0];
    const formData = new FormData();
    // if (get(this.props, "AuthenticationAction.IsFulfilled", "")) {
    //   formData.append("file", file);
    // } else {
    //   formData.append("file", file);
    // }
    formData.append("file", file);
    if (files.length == 0) {
      this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
        variant: "error",
      });
      return false;
    }
    let extFile = "";
    const imgname = file.name;
    let idxDot = "";
    idxDot = imgname.lastIndexOf(".") + 1;
    extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    if (file.size > 2097152) {
      this.props.enqueueSnackbar(
        "Please Upload Valid Size Image (Maxsize : 2MB)",
        {
          variant: "error",
        },
      );
      this.setState({ file: null, imgname: "" });
    } else if (
      !(
        extFile == "png" ||
        extFile == "jpg" ||
        extFile == "jpeg" ||
        extFile == "pdf" ||
        extFile == "docx" ||
        extFile == "xlsx"
      )
    ) {
      this.props.enqueueSnackbar("Please Upload valid file", {
        variant: "error",
      });
      const { errors } = this.state;
      errors.ProfileImg = true;
      this.setState({
        img: null,
        errors,
        file: null,
        imgname: null,
        idxDot: null,
        extFile: null,
      });
      return null;
    } else {
      instanceMultipart
        .post(
          `/subscription/uploaddefault/${get(
            this.props,
            "SubscriptionInfo.SubscriptionData.accountid",
            "",
          )}/${get(
            this.props,
            "SubscriptionInfo.SubscriptionData.subscriptionid",
            "",
          )}/0`,
          formData,
        )
        .then((resp) => {
          // const { fields } = this.state;
          // fields[imgname] = resp.data.result[0].imagepath;
          this.setState({
            file: resp.data.result[0].imagepath,
            imgname: file.name,
          });
        });

      // this.setState({
      //   file,
      //   imgname: file.name,
      // });
    }
  }

  onCreateAuthority() {
    this.setState({
      open: !this.state.open,
      employeefullname: "",
      fathername: "",
      imgname: "",
      designationname: "",
      genderid: null,
      signaturepath: "",
      selectedgender: null,
      signingauthorityid: null,
      selectedemployee: null,
      isexisting: false,
      drawertype: "createauth",
    });
  }

  onEdit = (id) => {
    const authority = get(this, "state.allsigningauthority", []).find(
      (authorityi) => authorityi.signingauthorityid == id,
    );
    const selectedgender = get(this, "state.genderList", "").find(
      (gender) => gender.displayvalue == authority.genderid,
    );
    this.setState({
      open: !this.state.open,
      ...authority,
      imgname: authority.signaturepath,
      selectedgender,
      isexisting: false,
    });
  };

  onFathernamechange(e) {
    if (e.target.value != "") {
      this.setState({
        fathername: e.target.value,
        ferror: false,
      });
    } else {
      this.setState({
        fathername: e.target.value,
        ferror: true,
      });
    }
  }

  onCancel() {
    this.setState({
      open: !this.state.open,
      employeefullname: "",
      fathername: "",
      imgname: "",
      designationname: "",
      genderid: null,
      signaturepath: "",
      selectedgender: null,
      signingauthorityid: null,
    });
  }

  onCloseDrawer = () => {
    this.setState({
      open: false,
      drawertype: "",
    });
  };

  ConfirmDelete(id) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.DeleteAuthority(id)}
        >
          Yes
        </Button>,
        <Button color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  DeleteAuthority(id) {
    const that = this;
    instance.delete(`payroll/signingauthority/${id}`).then(
      () => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.setState(
          {
            allsigningauthority: [],
            offset: 0,
          },
          () => {
            that.GetAllSigningAuthority();
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  onSearch(e) {
    if (e.target.value != "") {
      const allsigningauthority = this.state.tempList.filter(
        (emp) =>
          emp.employeefullname
            .toLowerCase()
            .search(e.target.value.toLowerCase()) !== -1,
      );
      this.setState({ searchValue: e.target.value, allsigningauthority });
    } else {
      this.setState({
        searchValue: e.target.value,
        allsigningauthority: this.state.tempList,
      });
    }
  }

  render() {
    const {
      allsigningauthority = [],
      drawertype,
      editingauthority,
      open,
      isexisting,
      data,
      timeline,
      selectedyear = null,
    } = this.state;
    const { classes } = this.props;
    return (
      data && (
        <IntlProvider locale="en" messages={""}>
          <div className="innerwrapper-full-width">
            <div>
              {allsigningauthority.length > 0 ? (
                <div className={classes.root}>
                  <Grid container className="config-table">
                    <Divider light />
                    <Grid container className="">
                      <Grid item xs={12} md={4} sm={3}>
                        {/* <div className="table-status">showing {allsigningauthority && allsigningauthority.length} signing authorities</div> */}
                      </Grid>
                      <Grid item xs={12} md={8} sm={8}>
                        <Grid container justify="flex-end" direction="row">
                          <div className="margin-right-20">
                            <DatePickerComponent
                              placeholder={"select year"}
                              start="Decade"
                              depth="Decade"
                              allowEdit={false}
                              border="1px solid #166ab3 !important"
                              format={"yyyy"}
                              hideClearIcon
                              change={(e) =>
                                this.setState(
                                  {
                                    selectedyear: e.value,
                                    startdate: moment(e.value).startOf("year"),
                                    enddate: moment(e.value).endOf("year"),
                                  },
                                  () => this.gettimeline(),
                                )
                              }
                              value={selectedyear || new Date()}
                            />
                          </div>
                          <Button
                            variant="contained"
                            color="primary"
                            className="btn btn-secondary-md-blue margin-right-16"
                            onClick={() =>
                              this.setState({
                                drawertype: "assign",
                                open: true,
                              })
                            }
                          >
                            Assign signing authority
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            className="btn btn-primary-md-blue"
                            onClick={this.onCreateAuthority}
                          >
                            Add signing authority
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container>
                      {allsigningauthority.length > 0 && timeline.length > 0 ? (
                        <SigningAuthTimeline timeline={timeline} />
                      ) : (
                        <div className="position-rel width100">
                          <DefaultComp
                            heading=" Add signing authority"
                            imageSrc={emptylist}
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <div>
                  <Create onCreateAuthority={this.onCreateAuthority} />
                </div>
              )}
            </div>
            <Drawer
              anchor="right"
              open={open}
              onClose={this.onCloseDrawer}
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              {drawertype == "assign" ? (
                <AssignForm
                  GetAllSigningAuthority={this.GetAllSigningAuthority}
                  editingauthority={editingauthority}
                  onCloseDrawer={this.onCloseDrawer}
                  allsigningauthority={allsigningauthority}
                  gettimeline={this.gettimeline}
                  {...this.props}
                />
              ) : (
                <div className="planner-right-drawer">
                  <DrawerHeader
                    header="Add signing authority"
                    isbackarrow={false}
                    closeDrawer={this.onCloseDrawer}
                  />
                  <div className="inner-wrapper opaque">
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isexisting}
                            onChange={(e) => this.handleChange(e)}
                            value={true}
                          />
                        }
                        label="is existing employee"
                      />
                    </div>
                    <div className="form-group padding-bottom-0">
                      <p className="input-form-label t-14">
                        <FormattedMessage
                          id="Lbemployeename"
                          defaultMessage="Employee name"
                        />
                      </p>
                      {!this.state.isexisting ? (
                        <TextField
                          className="width100"
                          id="challenged"
                          margin="dense"
                          variant="outlined"
                          value={this.state.employeefullname}
                          onChange={(e) =>
                            this.OnFieldChange("employeefullname", "text", e)
                          }
                        />
                      ) : (
                        <Select
                          className="selectsearch width100"
                          onInputChange={this.SearchEmployee}
                          onChange={(e) =>
                            this.onBlurChange("employeefullname", "change", e)
                          }
                          options={this.state.emplist}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.selectedemployee}
                          placeholder=""
                        />
                      )}
                    </div>
                  </div>
                  <div className="inner-wrapper opaque margin-top-10">
                    <div className="form-group padding-bottom-0">
                      <p className="input-form-label t-14">
                        <FormattedMessage
                          id="Lbfathername"
                          defaultMessage="Father name"
                        />
                      </p>
                      <TextField
                        className="width100"
                        id="challenged"
                        margin="dense"
                        variant="outlined"
                        value={this.state.fathername}
                        onChange={(e) =>
                          this.OnFieldChange("fathername", "text", e)
                        }
                        onBlur={this.onFathernamechange}
                      />
                    </div>
                  </div>
                  {!this.state.isexisting && (
                    <div>
                      <div className="inner-wrapper opaque margin-top-10">
                        <div className="form-group padding-bottom-0">
                          <p className="input-form-label t-14">
                            <FormattedMessage
                              id="Lbdesignation"
                              defaultMessage="Designation"
                            />
                          </p>
                          <TextField
                            className="width100"
                            id="challenged"
                            margin="dense"
                            variant="outlined"
                            value={this.state.designationname}
                            onChange={(e) =>
                              this.OnFieldChange("designationname", "text", e)
                            }
                          />
                        </div>
                      </div>
                      <div className="inner-wrapper opaque margin-top-10">
                        <div>
                          <p className="input-form-label t-14">
                            <FormattedMessage
                              id="Lbgender"
                              defaultMessage="Gender"
                            />
                          </p>
                          <Select
                            id="challenged"
                            options={this.state.genderList}
                            value={this.state.selectedgender}
                            getOptionLabel={(option) => option.displayname}
                            getOptionValue={(option) => option.displayvalue}
                            onChange={(e) =>
                              this.OnFieldChange("genderid", "number", e)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {/* <div className="margin-top-20">
                    {this.state.imgname ? (
                      <div>
                        <Dropzone
                          onDrop={this.getFiles1.bind(this)}
                          multiple={false}
                          accept="image/gif, image/jpeg, image/png, image/jpg"
                          maxSize={2000000}
                          className="drag-drop floatleft"
                        >
                          <div
                            style={{
                              fontFamily: "Muli",
                              fontSize: 12,
                              color: "#1E8CED",
                              cursor: "pointer",
                              paddingTop: 8,
                            }}
                          >
                            Replace signature
                          </div>
                        </Dropzone>

                        <img
                          style={{
                            width: 130,
                            height: 35,
                            objectFit: "contain",
                          }}
                          src={getFormattedImageLink(this.state.file)}
                        />
                      </div>
                    ) : (
                      <div
                        className="add-attachment"
                        style={{
                          width: 130,
                          padding: 6,
                          height: 35,
                          textAlign: "center",
                        }}
                      >
                        <Tooltip title="Insert attachment" placement="right">
                          <Dropzone
                            onDrop={this.getFiles1.bind(this)}
                            multiple={false}
                            accept="image/gif, image/jpeg, image/png, image/jpg"
                            maxSize={2000000}
                            className="drag-drop"
                          >
                            <Add
                              className="add-attachement-icon"
                              style={{ marginLeft: 0, marginTop: 0 }}
                            />
                            <div
                              style={{
                                fontFamily: "Muli",
                                fontSize: 12,
                                color: "#057cff",
                              }}
                            >
                              Upload signature
                            </div>
                          </Dropzone>
                        </Tooltip>
                      </div>
                    )}
                    <div className="clear-float"> </div>
                    <p className="input-label">
                      Note: Upload attachment with max size 2 MB for optimum
                      results. (Supports .gif, .jpeg, .jpg and .png file types)
                    </p>
                  </div> */}
                  <div className="margin-top-40 clear-left">
                    <Button
                      className="btn btn-primary-md-blue margin-right-8"
                      onClick={this.OnFormSubmit}
                    >
                      Save
                    </Button>
                    <Button
                      className="btn btn-secondary-md-blue"
                      onClick={this.onCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </Drawer>
          </div>
        </IntlProvider>
      )
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(SigningAuthority)));

// const DATA = {
//   error: null,
//   result: [
//     {
//       signingauthorityid: 3,
//       signingauthority: [
//         {
//           authorizedforid: 1,
//           authorizedfor: "Pay Slip",
//           signingauthorityid: 3,
//           authoritydetailid: 1,
//           isdefault: false,
//           effectivefrom: "2019-01-01",
//           effectiveto: null,
//           employeeid: 765,
//           employeefullname: "Rashmi Manatkar",
//           imagepath: null,
//           fallbackforid: null,
//           fallbackfullname: null,
//         },
//       ],
//     },
//   ],
// };
